import React, { useEffect, useState } from 'react';
import TeachHeader from './TeachHeader';
import axios from '../Axiosinstance';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { Box } from '@mui/system';

function NotificationTable() {
  const [notifications, setNotifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [notificationsPerPage] = useState(5); // Number of notifications per page
  const studentTeacherId = localStorage.getItem('studentteacherid');

  useEffect(() => {
    axios.get('notifications')
      .then((response) => {
        const filteredNotifications = response.data.filter((notification) =>
          notification.teacherIds.includes(Number(studentTeacherId))
        );
        filteredNotifications.sort((a, b) => b.id - a.id);
        setNotifications(filteredNotifications);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [studentTeacherId]);

  // Calculate the indices of the current page
  const indexOfLastNotification = currentPage * notificationsPerPage;
  const indexOfFirstNotification = indexOfLastNotification - notificationsPerPage;
  const currentNotifications = notifications.slice(indexOfFirstNotification, indexOfLastNotification);

  // Handle page change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <Box sx={{ padding: '20px' }}>
      <TeachHeader />
      <Typography variant="h4" gutterBottom align="center" sx={{ marginTop: '-14px' }}>
        Notifications
      </Typography>

      <TableContainer component={Paper} sx={{ maxWidth: '90%', margin: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{fontWeight:'bold'}}>S.No</TableCell>
              <TableCell style={{fontWeight:'bold'}}>Subject</TableCell>
              <TableCell style={{fontWeight:'bold'}}>Message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentNotifications.length > 0 ? (
              currentNotifications.map((notification, index) => (
                <TableRow key={notification.id}>
                  <TableCell>{indexOfFirstNotification + index + 1}</TableCell>
                  <TableCell>{notification.subject}</TableCell>
                  <TableCell>{notification.message}</TableCell>
                </TableRow>
              ))
            ) : (
              // Display this row when no notifications are available
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No notifications available at the moment.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination Controls */}
      {notifications.length > 0 && (
        <Box display="flex" justifyContent="center" sx={{ marginTop: '20px' }}>
          <Pagination
            count={Math.ceil(notifications.length / notificationsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            variant="outlined"
          />
        </Box>
      )}
    </Box>
  );
}

export default NotificationTable;
